import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'

const H2 = ({ children, fontWeight, marginBottom, marginTop, withBorder, ...rest }) => (
  <ThemeProvider theme={theme}>
    <Heading className={cn({ marginBottom, marginTop, withBorder }, fontWeight)} {...rest}>
      {children}
    </Heading>
  </ThemeProvider>
)

const Heading = styled.h2`
  font-size: ${props => props.theme.typography.fontSizeMed};
  font-weight: ${props => props.theme.typography.fontWeightBold};
  color: ${`var(--gameday-body-headingColor, ${theme.body.headingColor})`};
  margin: 0px;
  &.light {
    font-weight: ${props => props.theme.typography.fontWeightNormal};
    font-size: ${props => props.theme.typography.fontSizeLgish};
  }
  &.marginBottom {
    margin-bottom: 16px;
  }
  &.marginTop {
    margin-top: 16px;
  }
  &.withBorder {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${props => props.theme.body.headingBorderColor};
  }
`

H2.defaultProps = {
  fontWeight: 'normal',
  marginBottom: false,
  marginTop: false,
  withBorder: false,
}

export default H2
